import { t } from 'i18next';
import * as yup from 'yup';

import { QuotePartNoteType } from 'quotes/enums';

export const quotePartAddNoteSchema = (types: QuotePartNoteType[]) =>
  yup.object().shape({
    notes: yup
      .object()
      .shape(
        types.reduce(
          (acc, type) => ({
            ...acc,
            [type]: yup.object().shape({
              enabled: yup.boolean().nullable().required(),
              content: yup
                .string()
                .label(t('labelNote'))
                .nullable()
                .test('required', t('errorTitleLineNotesRequired'), (value, { parent }) => {
                  if (!parent.enabled || type === QuotePartNoteType.UNDISCARDABLE_ITEM) {
                    return true;
                  }

                  if (type === QuotePartNoteType.LEAD_TIME) {
                    return !!value || parent.hasLeadTime;
                  }

                  return !!value;
                }),
            }),
          }),
          {}
        )
      )
      .test('atLeastOneEnabled', t('errorNoteRequired'), (value) => {
        return Object.values(value).some((note: { enabled: boolean }) => note.enabled);
      }),
  });
